<template>
    <div id="app"
        class="app"
        :class="appClassName">
        <!-- 头部 -->
        <the-header
            :isInQueue="isInQueue"
            :chatTarget="chatTarget"
            :isSupportHuman="isSupportHuman"
            :showCompanyLogoOrName="showCompanyLogoOrName"
            @getChatHost="getChatHost"
            @setChatHost="setChatHost"
        ></the-header>
        <div class="content-wrap app-content-wrap">
            <div class="left">
                <!-- 消息区 -->
                <the-message-list
                    ref="messageList"
                    :isInQueue="isInQueue"
                    :messageList="messageList"
                    :chatTarget="chatTarget"
                    :theLastEventQueueId="theLastEventQueueId"
                    @getChatHost="getChatHost"
                    @setChatHost="setChatHost"></the-message-list>
                <!-- 底部输入拦-->
                <the-footer
                    :extendType="extendType"
                    :extendData="extendData"
                    :hotWords="hotWords"
                    :chatTarget="chatTarget"
                    :relatedQuestion="relatedQuestion"
                    @sendFirstChat="sendFirstChat"
                    @setRelatedQuestion="setRelatedQuestion"></the-footer>
                <template v-if="isready">
                    <!-- 年龄选择器 -->
                    <range-picker
                        :range="ageRange"
                        :defaultIndex="34"
                        name="age"></range-picker>
                    <!-- 金额选择器 -->
                    <range-picker
                        :range="moneyRange"
                        :defaultIndex="4"
                        name="money"></range-picker>
                    <!-- 日期选择器 -->
                    <datetime-picker
                        name="date"></datetime-picker>
                    <!-- 评价dialog -->
                    <the-evaluation-dialog></the-evaluation-dialog>
                    <!-- 留言dialog -->
                    <the-leave-message-dialog></the-leave-message-dialog>
                    <!-- 询前dialog -->
                    <the-before-dialog></the-before-dialog>
                    <!-- 选择客服技能组dialog -->
                    <the-skill-group ref="skillGroup" />
                </template>
            </div>
            <div class="right" v-if="isInSession && !isMobile && sidebar.enable" :style="{'--width': sidebar.width +'px' }">
                <sidebar :options="sidebar"></sidebar>
            </div>
        </div>

    </div>
</template>

<script>
    import TheHeader from '@/components/TheHeader'
    import TheFooter from '@/components/TheFooter'
    import TheMessageList from '@/components/TheMessageList'
    import RangePicker from '@/components/RangePicker'
    import DatetimePicker from '@/components/DatetimePicker'
    import TheEvaluationDialog from '@/components/TheEvaluationDialog'
    import TheLeaveMessageDialog from '@/components/TheLeaveMessageDialog'
    import TheBeforeDialog from '@/components/TheBeforeDialog'
    import TheSkillGroup from '@/components/TheSkillGroup'
    import { /* EXTEND_TYPE, */ CHAT_TARGET } from '@/constants/message'
    import { getUid, getServiceStatus, postRquestParams } from '@/api/chat'
    import { recordBrowseTracks, recordBrowseVisit, startBrowseTracks } from '@/api/browse_tracks'
    import { skillGroups } from '@/api/skill_group'
    import { getTokenConfig, getToken } from '@/api/token'
    import { inObjectValues, intRange, getRequest, isIPhoneX } from '@/utils'
    import { removeElementById, getStyle } from '@/utils/dom'
    import timer from '@/utils/timer'
    import initWechatSDK from '@/utils/wechat_sdk'
    import chatMixin from '@/mixins/chat'
    import chatUtilMixin from '@/mixins/chat_util'
    import unreadMixin from '@/mixins/unread'
    import historyMixin from '@/mixins/history'
    import reconnectMixin from '@/mixins/reconnect'
    import settingMixin from '@/mixins/setting'
    import sidebar from '@/components/sidebar'

    // import { EXTEND_DATA } from '@/assets/data/mock'
    // import mockMixin from '@/mixins/init_mock' // 模拟消息数据

    /**
     * 处理“扩展功能”面板的数据
     *
     * @param { Boolean } isOpenEntry - 是否开启“扩展功能”
     * @param { String } type - “扩展功能”的类型，imgText | text
     * @param { functions } functions - 类型对应的数据
     * @returns { Array } 最终的扩展功能列表，若为空数组，则隐藏该功能
     */
    /* function handleExtendData ({ isOpenEntry, type, functions }) {
        if (!isOpenEntry || !(inObjectValues(EXTEND_TYPE, type))) {
            return []
        }
        return functions[`${type}s`]
    } */

    const IPHONE_X_CLASSNAME = 'iphone-x-fit'

    // 年龄：1岁~86岁
    const AGE_RANGE = intRange(86, 1).map(item => `${item}岁`)
    // 家庭收入：[1, 29] * 5
    const MONEY_RANGE = intRange(29, 1).map(item => `${item * 5}万`)

    export default {
        name: 'app',

        mixins: [
            settingMixin,
            chatUtilMixin,
            chatMixin,
            unreadMixin,
            historyMixin,
            reconnectMixin/*,
            mockMixin */
        ],

        components: {
            TheHeader,
            TheFooter,
            TheMessageList,
            TheEvaluationDialog,
            TheLeaveMessageDialog,
            TheBeforeDialog,
            TheSkillGroup,
            RangePicker,
            DatetimePicker,
            sidebar
        },

        data () {
            return {
                isInQueue: false,
                chatTarget: '',
                theLastEventQueueId: '',
                extendData: [], // handleExtendData(EXTEND_DATA),
                extendType: '', // EXTEND_DATA.type,
                relatedQuestion: [],
                ageRange: AGE_RANGE,
                moneyRange: MONEY_RANGE,
                parentDomainConfig: {
                    name: '',
                    url: '',
                    domain: '',
                    referrer: ''
                },
                unique_id: '',
                isready: false,
                showSkillGroupPop: false,
                isApp: false
            }
        },

        computed: {
            uid () {
                return this.$eventBus.uid
            },
            companyCode () {
                return this.$eventBus.companyCode
            },
            entryKey () {
                return this.$eventBus.entryKey
            },
            hotWords () {
                return this.$eventBus.hotWords
            },
            appClassName () {
                return [{
                    'is-desktop': this.$eventBus.isDesktop,
                    'is-ie': this.$eventBus.isIENotIncludeEdge,
                    'is-mobile': this.$eventBus.isMobile,
                    'is-ios': this.$eventBus.isIos,
                    'is-android': this.$eventBus.isAndroid,
                    'is-app': this.isApp,
                    'is-iphonex': this.$eventBus.isIphonex
                }, `theme-${this.$eventBus.theme}`]
            },
            isMobile () {
                return this.$eventBus.isMobile
            },
            isInSession () {
                return this.$store.state.isInSession
            }
        },

        watch: {
            'parentDomainConfig.domain' (domain, old) {
                old && recordBrowseVisit({
                    chat_user_id: this.uid,
                    domain
                })
            },
            unique_id (id) {
                this.$eventBus.setUniqueId(id)
            }
        },

        methods: {
            async getToken () {
                if (this.$eventBus.code) {
                    await this.code2Token(this.$eventBus.code)
                    return
                }
                const token = sessionStorage.getItem('customer-token')
                const isMiniProgram = window.__wxjs_environment === 'miniprogram' || navigator.userAgent.indexOf('miniprogram') > -1
                if (token || isMiniProgram) {
                    // 小程序环境下不获取token
                    this.init()
                    return
                }
                return getTokenConfig()
                    .then(({lynk_authorizztion_url, client_id, scope}) => {
                        const ua = navigator.userAgent
                        if (ua.indexOf('x-cordova-platform') > -1) {
                            let flag = 0
                            this.isApp = true
                            const cordovaInit = () => {
                                console.log(flag)
                                // eslint-disable-next-line
                                if (typeof cordova !== 'undefined' && typeof cordova.exec === 'function') {
                                    console.log('调用cordova')
                                    flag = 0
                                    // 环境为APP内
                                    const success = res => {
                                        console.log(res)
                                        if (res.code === '1000') {
                                            this.code2Token(res.data.code)
                                        }
                                    }
                                    const fail = err => {
                                        console.log('失败日志'+err)
                                    }
                                    const channel = getRequest().channel
                                    if (['jh_app', 'jhmall_app', 'jhcollection_app'].includes(channel)) {
                                        // eslint-disable-next-line
                                        cordova.exec(success, fail, 'GMUserSessionPlugin', 'getAuthorization', [{
                                            clientId: client_id, // 应用Id
                                            scope: scope, // 作用域
                                            responseType:'code' //效应类型
                                        }])
                                        this.isApp = false
                                    } else {
                                        // eslint-disable-next-line
                                        cordova.exec(success, fail, 'SWXUserSessionPlugin', 'getAuthorization', [{
                                            clientId: client_id, // 应⽤Id
                                            scope: scope // 作⽤域
                                        }])
                                    }
                                } else {
                                    setTimeout(()=> {
                                        if (flag < 10) {
                                            flag += 1
                                            cordovaInit()
                                        }
                                    }, 200)
                                }
                            }

                            cordovaInit()
                        } else {
                            const redirect_uri = encodeURIComponent(location.href.replace('&state=service_h5', ''))
                            sessionStorage.setItem('redirect_uri', redirect_uri)
                            window.location.replace(`${lynk_authorizztion_url}?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code&state=service_h5&scope=openid`)
                        }
                    })
            },
            async code2Token (code) {
                const { access_token, openid } = await getToken(code)
                sessionStorage.removeItem('redirect_uri')
                sessionStorage.setItem('customer-openid', openid)
                sessionStorage.setItem('customer-token', access_token)
                window.history.replaceState({}, '', window.location.href.replace(`&code=${code}`, ''))
                this.$eventBus.clearCode()
                this.init()
            },
            validateInitParam () {
                return this.entryKey && this.companyCode
            },
            async init () {
                if (!this.validateInitParam()) {
                    this.$toast('缺少初始化参数')
                    return
                }
                this.$toast.loading({
                    duration: 0,
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'circular'
                })

                const res = await getUid(this.companyCode)
                    .catch(() => {
                        sessionStorage.removeItem('customer-token')
                        sessionStorage.removeItem('customer-openid')
                        // return this.getToken()
                        return
                    })
                this.$eventBus.setUid(res.chat_user_id)
                initWechatSDK()
                this.bindRootEvents()
                this.exposeChatUtils()
                this.bindChatSendEvents()
                this.bindUnreadEvents()

                this.setGuideAndOtherConfig()
                this.setSkillGroups()
                this.getChatHost()
                this.getParams()
                // this.postLastUnPostMessage()
                this.initHistory()
                this.initSocket()
                this.$eventBus.getCurrentHumanUser()
                this.isready = true
            },
            bindRootEvents () {
                document.body.addEventListener('click', this.setMessageReadDebounced, false)
            },
            unbindRootEvents () {
                document.body.removeEventListener('click', this.setMessageReadDebounced, false)
            },
            async getChatHost () {
                try {
                    const { status } = await getServiceStatus(this.uid)
                    this.setChatHost(status)
                } catch (err) {
                    // eslint-disable-next-line
                    console.error(err)
                }
            },
            /**
             * 设置聊天对象：人工 or 机器人
             */
            setChatHost (status) {
                if (inObjectValues(CHAT_TARGET, status)) {
                    this.chatTarget = status
                    this.$store.commit('setData', {
                        key: 'chatTarget',
                        value: status
                    })
                    this.isInQueue = false
                } else if (status === 'queue') {
                    this.isInQueue = true
                }
            },
            setRelatedQuestion (relatedQuestion) {
                this.relatedQuestion = relatedQuestion
            },
            /**
             * 目前只有 footer 在 Mounted 时存在该类名
             */
            detectIphonx () {
                const dom = document.getElementsByClassName(IPHONE_X_CLASSNAME)
                if (dom && dom.length > 0) {
                    // iphone x: 34px
                    return parseFloat(getStyle(dom[0], 'padding-bottom')) > 0 || isIPhoneX()
                }
                return false
            },


            // @contextmenu.native="preventContextMenu"
            // preventContextMenu (event) {
            //     event.preventDefault()
            // }
            // 获取父页面url和title
            getParentDomainConfig (e) {
                // console.log('window.onmessage', e.data)
                if (e.data.name && e.data.url) {
                    this.parentDomainConfig = e.data
                    if (this.unique_id) {
                        recordBrowseTracks({
                            name: this.parentDomainConfig.name,
                            url: this.parentDomainConfig.url,
                            unique_id: this.unique_id,
                            chat_user_id: this.uid,
                            entry_id: this.entryKey
                        }).then(({ unique_id }) => {
                            this.unique_id = unique_id
                        })
                    }
                    // window.removeEventListener('message', this.getParentDomainConfig)
                }
            },
            sendFirstChat () {
                this.unique_id && startBrowseTracks({
                    chat_user_id: this.uid,
                    browse_tracks_id: this.unique_id
                })
            },
            getParams () {
                if (getRequest().hp) {
                    postRquestParams(this.uid, getRequest())
                }
            },
            async setSkillGroups () {
                const list = await skillGroups()
                this.$store.commit('setSkillGroup', {
                    key: 'list',
                    value: list
                })
            }
        },

        async created () {
            await this.getToken()
            window.isLoaded = true
            const loadingEl = document.querySelector('#page-loading')
            if (loadingEl) {
                loadingEl.style.opacity = '0'
                setTimeout(() => {
                    removeElementById('page-loading')
                }, 500)
            }

            window.addEventListener('message', this.getParentDomainConfig)
        },

        mounted () {
            this.$eventBus.isIphonex = this.detectIphonx()
        },

        beforeDestroy () {
            this.unbindRootEvents()
            timer.clear()
        }
    }
</script>

<style lang="scss">
    @import "~styles/base/reset";
    @import "~styles/base/iconfont";
    @import "~styles/base/swiper_override";
    @import "~styles/base/picker_override";

    html,
    body,
    .app {
        height: 100%;
        overflow: hidden;
    }

    body {
        background-color: #ffffff;
    }

    .app {
        display: flex;
        flex-direction: column;
        background-color: #F3F4F6;
        padding-top: constant(safe-area-inset-top, 40px); /* Older iOS */
        padding-top: env(safe-area-inset-top, 40px); /* Newer iOS */
        .content-wrap {
            flex: 1;
            .left {
                height: 100%;
                display: flex;
                flex-direction: column;
            }
        }
        .app-content-wrap {
            height: 0;
        }
        &.is-desktop {
            position: absolute;
            width: fit-content;
            max-height: 800px;
            height: 100%;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            border-radius: 4px;
            overflow: hidden;
            box-shadow: 0 2px 10px 0 rgba(0,0,0,0.50);
            transform: translateZ(0);

            .content-wrap {
                height: 100%;
                display: flex;
            }
            .left {
                height: 100%;
                display: flex;
                flex-direction: column;
                flex:1;
                min-width: 660px;
            }
            .right {
                width: var(--width);
            }
        }

        &.is-mobile:not(.theme-white) {
            .footer__main {
                background: #000;
                .action__icon {
                    color: #fff;
                }
            }
        }
        &.is-mobile.theme-white {
            .editor__input {
                color: #666666
            }
        }
        &.is-app {
            padding-top: 22px;
            &:not(.theme-white) {
                background: #000;
            }
            &.is-iphonex {
                padding-top: 44px;
            }
        }
    }

    .app.is-desktop {
        .header, .footer {
            flex-grow: 0;
            flex-shrink: 0
        }

        .message-list {
            flex-grow: 1;
        }
    }
    .app.is-mobile .message-list{
        flex: 1;
    }
    .message-list {
        height: 0;
    }

    .form__income {
        color: #333;
        &::placeholder {
            color: #999;
            opacity: 1;
        }
        &:-ms-input-placeholder{
            color:#999;
        }
        &::-webkit-input-placeholder{
            color:#999;
        }
        &.placeholder {
            color:#999;
        }
    }

    .rotate {
        animation: rotate 2s linear infinite;
    }

    @keyframes rotate {
        0% {
            transform: rotateZ(0deg);
        }
        100% {
            transform: rotateZ(360deg);
        }
    }

    .is-desktop {
        * {
            user-select: text;
        }

        .van-popup * {
            user-select: none;
        }

        .van-dialog {
            max-width: 340px;
            width: 90%;
        }
        .van-toast {
            max-width: 260px;
        }

        ::-webkit-scrollbar {
            width: 5px;
        }

        ::-webkit-scrollbar-track {
            background-color: transparent;
        }

        ::-webkit-scrollbar-thumb {
            border-radius: 3px;
            background: rgba(0, 0, 0, 0.1);
        }
    }
</style>
